// export const API_BASE_URL = "https://social-tv.tmyamz.com/api/";
// export const SOCKET_BASE_URL = "https://social-tv.tmyamz.com/";

// Klarion
export const API_BASE_URL = "https://social-tv.klarion.media/api/";
export const SOCKET_BASE_URL = "https://social-tv.klarion.media/";

// export const API_BASE_URL = "http://192.168.1.8:5000/api/";
// export const SOCKET_BASE_URL = "http://192.168.1.8:5000/";

export const API_ENDPOINTS = {
    GET_CREATIVES: "/creatives",
    GET_CREATIVE: (id) => `/creatives/${id}`
};